import { ENABLE_LOGGED_OUT_CATEGORY_PAGE_REDESIGN_241016 } from "@faire/web-api/indigofair/settings/ENABLE_LOGGED_OUT_CATEGORY_PAGE_REDESIGN_241016";

import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingLoggedOutCategoryPageRedesign = () => {
  return useSetting(ENABLE_LOGGED_OUT_CATEGORY_PAGE_REDESIGN_241016, false);
};

export const useAssignSettingLoggedOutCategoryPageRedesign = () => {
  return useAssignSetting(ENABLE_LOGGED_OUT_CATEGORY_PAGE_REDESIGN_241016);
};
